import { Dialog,CircularProgress } from "@mui/material";
import "./Loader.css";
export default function Loader(props) {
  return (
    <Dialog
      className="loader"
      aria-labelledby="simple-dialog-title"
      open={props.open}
      disableEnforceFocus
      disableAutoFocus
      disableRestoreFocus
    >
      <div className="progress">
        <CircularProgress />
      </div>
    </Dialog>
  );
}
